"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridHeaderRenderer = void 0;
const react_1 = __importDefault(require("react"));
const GridHeaderCell_1 = require("./components/GridHeaderCell/GridHeaderCell");
const GridHeaderContainer_1 = require("./components/GridHeaderContainer/GridHeaderContainer");
function createGridHeaderRenderer() {
    return function gridHeaderRenderer({ columns, containerRef, rowWidth, className, style }) {
        return (react_1.default.createElement(GridHeaderContainer_1.GridHeaderContainer, { key: "header-container", containerRef: containerRef, style: Object.assign({ width: rowWidth }, style), className: className }, columns.map((config, idx) => {
            var _a;
            return (react_1.default.createElement(GridHeaderCell_1.GridHeaderCell, { key: `header-cell-${config.id}`, style: {
                    width: config.width,
                    minWidth: config.width,
                    maxWidth: config.width,
                    flexBasis: config.width
                } }, (_a = config.header) === null || _a === void 0 ? void 0 : _a.call(config, { cellIndex: idx, column: config })));
        })));
    };
}
exports.createGridHeaderRenderer = createGridHeaderRenderer;
//# sourceMappingURL=createGridHeaderRenderer.js.map